var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.365 3.784l2.374-2.373a2.555 2.555 0 0 1 3.624 0l20.782 20.772a2.555 2.555 0 0 1 0 3.624L26.363 46.589a2.555 2.555 0 0 1-3.624 0l-2.374-2.373a2.569 2.569 0 0 1 .043-3.667L33.29 28.276H2.566A2.56 2.56 0 0 1 0 25.71v-3.42a2.56 2.56 0 0 1 2.566-2.566H33.29L20.408 7.45a2.55 2.55 0 0 1-.043-3.667z"
  }))));
};
export default SvgArrow;